import type { DialogLayerApi } from "../../components/Dialog/dialogStack";
import { inject } from "vue";
import { DIALOG_LAYER_KEY } from "../../components/Dialog/dialogStack";

export function useDialogLayer(): DialogLayerApi {
  const layer = inject(DIALOG_LAYER_KEY, null);
  if (!layer) {
    throw new Error("useDialogLayer() must be used inside a dialog layer");
  }
  return layer;
}

export function tryUseDialogLayer(): DialogLayerApi | null {
  return inject(DIALOG_LAYER_KEY, null);
}

/** Dismiss `layer` after a successful write. No-op when no layer is mounted. */
export async function closeAfterSave(layer: DialogLayerApi | null | undefined): Promise<boolean> {
  if (!layer) {
    return true;
  }
  return layer.closeAfterSave();
}
